export default "__VITE_ASSET__D3Ddp2Mi__"